module.exports = __webpack_public_path__ + "static/media/extra-services-icon.f41b3b0f.svg";